import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { SupervisorSkill } from './supervisor-skill'
import { SupervisorSkillSerializer } from './supervisor-skill.serializer'
import { PaginatedResponse } from 'src/app/shared/interfaces'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { buildHttpParams } from 'src/app/shared/query-utils'
import { Booking } from '../../booking/booking'

@Injectable()
export class SupervisorSkillService extends ResourceService<SupervisorSkill> {
  constructor(
    private http: HttpClient,
    private supervisorSkillSerializer: SupervisorSkillSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/supervisor-skills`,
      supervisorSkillSerializer
    )
  }
}
